import { FormikProps } from 'formik';
import { FC } from 'react';

import styles from 'src/checkout/templates/Checkout/Forms/CheckoutForm.module.scss';
import {
  FinanceQuoteInfoFormValues,
  residencyStatusOptions,
} from 'src/checkout/templates/Checkout/Forms/CheckoutForm.type';
import { FINANCE_RESIDENCY_STATUS, RESOLUTION_OF_STATUS_VISA_SUBCLASS } from 'src/data/FinanceApi/FinanceApi.types';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { InputFormik } from 'src/general/components/forms/Input/InputFormik';
import { InputSelectFormik } from 'src/general/components/forms/Input/InputSelectFormik';
import { InputTimeFormik } from 'src/general/components/forms/Input/InputTimeFormik';
import { EmploymentCitizenshipFormValues } from 'src/personalised-quote/templates/Forms/PersonalizedQuoteForm.type';
import { getMicrocopy, getMicrocopyBulk } from 'src/stores/microcopyStore';

interface FinanceResidencyStatusFieldsProps {
  formikProps: FormikProps<FinanceQuoteInfoFormValues> | FormikProps<EmploymentCitizenshipFormValues>;
}

export const FinanceResidencyStatusFields: FC<FinanceResidencyStatusFieldsProps> = ({ formikProps }) => {
  const { values } = formikProps;

  const { visaInformationHeader, visaInformationDescription, visaInformationDisclaimer } = getMicrocopyBulk({
    visaInformationHeader: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_INFO_FORM_VISA_INFORMATION_HEADER],
    visaInformationDescription: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_INFO_FORM_VISA_INFORMATION_DESCRIPTION, true],
    visaInformationDisclaimer: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_INFO_FORM_VISA_INFORMATION_DISCLAIMER],
  });
  return (
    <>
      <InputSelectFormik
        name="residencyStatus"
        id="residencyStatus"
        label="Residency status"
        data-testid="residency-status-option"
        options={residencyStatusOptions.map((item) => ({
          value: item.value,
          label: getMicrocopy(item.label),
        }))}
        allowEmpty
      />
      {values.residencyStatus === FINANCE_RESIDENCY_STATUS.TEMPORARY_RESIDENT && (
        <div className={styles.radioHeader}>
          <p className={styles.visaInformationDescription}>{visaInformationDisclaimer}</p>
          <p className={styles.fieldTitle}>{visaInformationHeader}</p>
          <div className={styles.visaSubclassNumber}>
            <InputFormik
              id="visaSubclassNumber"
              type="numeric"
              name="visaSubclassNumber"
              label="Visa subclass number"
            />
          </div>
          <div className={styles.visaInformationDescription}>{visaInformationDescription}</div>
          {values.visaSubclassNumber.toString().trim() !== RESOLUTION_OF_STATUS_VISA_SUBCLASS && (
            <div className={styles.visaExpiryDate}>
              <InputTimeFormik label="Visa expiry date" name="visaExpiryDate" variant="date" id="visaExpiryDate" />
            </div>
          )}
        </div>
      )}
    </>
  );
};
